<div class="app">
    <pf-loading-overlay />
    <lib-toastmessage />
    <div [style.display]="router.url === '/' ? 'none' : 'block'">
        <pf-navigationmodule
            [nameOfTheSite]="title"
            [logoPosition]="positionL"
            [hasLogo]="false"
            [isShoppingCart]="false"
            [hasLogin]="hasLogin"
            [colorOfNavBar]="colorOfNavBar"
            [isAdmin]="true"
            [adminHomeUrl]="adminHomeUrl"
        />
    </div>
    <div class="router-outlet">
        <router-outlet (activate)="loadRouterOutletInput($event)" />
    </div>
</div>
<div class="footer-container">
    <div class="footer-admin">
        <h1></h1>
    </div>
</div>
